import React, {useState, useMemo} from "react";
import {
    darken,
    Dialog,
    DialogTitle,
    IconButton,
    lighten,
    List,
    ListItem,
    Slide,
    styled,
    Typography
} from "@mui/material";
import {THEME_CONFIG} from "../../../config";
import pleshDark from "../../../theme/pleshDark";
import {Close} from "@mui/icons-material";
import {getTranslatedAnswers} from "../../../functions/getTranslatedAnswers";
import useLanguageStore from "../../../store/languageStore";

const {poll, pollBorder, pollTextColor, borderRadius} = THEME_CONFIG

export default function ColorQuizQuestion({risposte, risposteTranslations, hideResult = false, answer, sendAnswer, isPoll}) {
    const { currentLanguage, defaultLanguage } = useLanguageStore();
    
    // Ottieni le risposte tradotte
    const translatedRisposte = useMemo(() => {
        const translated = getTranslatedAnswers(risposte, risposteTranslations, currentLanguage, defaultLanguage);
        
        // Per ColorQuizQuestion, le risposte sono oggetti con label e color
        // Mantieni la struttura originale ma aggiorna solo il label
        if (translated && risposte && risposte.length > 0 && typeof risposte[0] === 'object') {
            // Se le traduzioni sono array di stringhe, mappali agli oggetti originali
            // Supporta traduzioni parziali: usa la traduzione se disponibile, altrimenti originale
            if (Array.isArray(translated) && typeof translated[0] === 'string') {
                return risposte.map((original, index) => ({
                    ...original,
                    label: translated[index] || original.label
                }));
            }
            // Se le traduzioni sono già oggetti, mappa solo quelli disponibili
            if (Array.isArray(translated) && translated.length > 0 && typeof translated[0] === 'object') {
                // Se hanno la stessa lunghezza, usa direttamente
                if (translated.length === risposte.length) {
                    return translated;
                }
                // Altrimenti, mappa le traduzioni disponibili e mantieni le originali per quelle mancanti
                return risposte.map((original, index) => {
                    return translated[index] || original;
                });
            }
        }
        
        return translated;
    }, [risposte, risposteTranslations, currentLanguage, defaultLanguage]);

    // Trova l'indice della risposta data (answer) nelle risposte originali
    const answerIndex = useMemo(() => {
        if (!answer || answer === '') return -1;
        return risposte.findIndex(r => {
            const originalLabel = r?.label || r;
            return originalLabel === answer;
        });
    }, [answer, risposte]);
    const RispostaStyled = styled(ListItem)({
        border: `2px solid ${pollBorder.default}`,
        borderRadius: borderRadius.default,
        background: poll.default,
        margin: '1rem 0',
        cursor: 'pointer',
        color: pollTextColor.default
    })

    const [openDialog, setOpenDialog] = useState(false);
    const [dialogColor, setDialogColor] = useState("transparent");

    const Risposte = () => (
        translatedRisposte?.map((r, i) => (
            <RispostaStyled key={i} style={{
                width: '100%',
                background: r.color,
                border: THEME_CONFIG.borders.default !== 'none' ? `2px solid ${darken(r.color, 0.5)}` : 'none',
                color: pleshDark.palette.getContrastText(r.color || pleshDark.palette.primary.main),
            }} onClick={() => rispondi(i)}>
                <Typography variant="h6" fontWeight='400' textAlign='center' width='100%' whiteSpace='pre-line'>
                    {r.label}
                </Typography>
            </RispostaStyled>
        ))
    )

    const rispondi = (index) => {
        // Usa l'indice per ottenere la risposta originale nella lingua di default
        const originalRisposta = risposte[index];
        const originalLabel = originalRisposta?.label || originalRisposta;
        
        if(isPoll) {
            sendAnswer(originalLabel)
        } else {
            if(answer === '') {
                sendAnswer(originalLabel)
            }
        }
        // Usa il colore dalla risposta tradotta per il dialog
        const translatedRisposta = translatedRisposte[index];
        setDialogColor(translatedRisposta?.color || 'transparent');
        setOpenDialog(true);
    }

    return (
        <List>
            <Risposte/>
            <Dialog
              fullScreen
              open={openDialog}
              TransitionComponent={Slide}
              PaperProps={{
                  style: {
                      backgroundColor: dialogColor,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                  },
              }}
              //sx={{visibility: hideResult ? 'hidden' : 'visible'}}
            >
                <DialogTitle>
                    <IconButton onClick={() => {
                        setOpenDialog(false)
                    }}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
            </Dialog>
        </List>
    )
}
